import { Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SceneApiService } from '../services/scene-api.service';
import { DeviceGroup } from './device-group.model';
import { SceneSchedules } from './scene-schedules.model';
import { SceneStatus } from './scene-status.model';

export class SceneBundle {
    constructor(deviceGroup: DeviceGroup, sceneStatus: SceneStatus, sceneScheduleSummary: string, private injector: Injector) {
        this.DeviceGroup = deviceGroup;
        this.SceneStatus = sceneStatus;
        this.SceneScheduleSummary = this.setSceneScheduleSummary(sceneScheduleSummary);
    }

    public DeviceGroup: DeviceGroup;
    public SceneStatus: SceneStatus;
    public SceneScheduleSummary: string;
    private _sceneSchedules: SceneSchedules;

    public SceneSchedules(useCache: boolean = true): Observable<SceneSchedules> {
        if (useCache && this._sceneSchedules) {
            return of(this._sceneSchedules);
        }

        return this.injector.get(SceneApiService).getSceneSchedules(this.DeviceGroup.Id)
            .pipe(
                map(response => {
                    this._sceneSchedules = new SceneSchedules(response);
                    return this._sceneSchedules;
                })
            );
    }

    public setSceneSchedules(sceneSchedules: SceneSchedules) {
        this._sceneSchedules.ScheduleA = sceneSchedules.ScheduleA;
        this._sceneSchedules.ScheduleB = sceneSchedules.ScheduleB;
    }

    private setSceneScheduleSummary(sceneScheduleSummary) {
        let summary = (sceneScheduleSummary && sceneScheduleSummary !== null) ? sceneScheduleSummary.replace(/<br\s*\/?>/gi, '') : '';
        sceneScheduleSummary = (summary == '') ? 'No schedules.' : sceneScheduleSummary.substring(0, sceneScheduleSummary.lastIndexOf('<br />'));
        return sceneScheduleSummary;
    }
}
